import { createComponent } from '@carvana/merch-components';

const Pulser = createComponent('div', {
  className: 'animate-pulse rounded-md bg-[#F4F8FA]'
});

export const SkeletonTextSmall = createComponent(Pulser, {
  className: 'h-16'
});

export const SkeletonTextMedium = createComponent(Pulser, {
  className: 'h-20 s:h-40'
});

export const SkeletonTextLarge = createComponent(Pulser, {
  className: 'h-48 m:h-64'
});

export const SkeletonImage = createComponent(Pulser, {
  className: 'h-[42vw] h-full w-full min-w-[50%] m:h-[268px] l:h-[278px]'
});
